/*
  Algolia "Search & Discovery" — official Custom Hooks customization.
  https://support.algolia.com → "[Shopify] How to set up Custom Hooks"

  The no-code app has no autocomplete template editor, so we extend the product
  row through the supported `beforeAutocompleteProductTemplate` hook. It runs
  inside the app's own render using data already in the Algolia index — NO extra
  network requests, no DOM observers.

  This app version's hook signature (confirmed via console):
    (defaultTemplate, { item, html, components })
  Returning `html`…`` replaces the row; returning `defaultTemplate` keeps the app
  default (used as a safe fallback so a field/API mismatch can't break the row).
*/
function ndiMoney(n) {
  // Index prices are dollar amounts (e.g. 3945, 338.15). USD only, which is fine
  // for this single-currency store.
  // ponytail: hardcoded USD; switch to the app's markets/currency helper if NDI
  // ever sells in multiple currencies.
  return '$' + Number(n || 0).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

function ndiShortDesc(item) {
  // body_html_safe wraps the real summary in [shortdesc]…[/shortdesc] (followed by
  // a [properties] block). Pull out just the summary; fall back to the raw text.
  var raw = item.body_html_safe || '';
  var m = raw.match(/\[shortdesc\]([\s\S]*?)\[\/shortdesc\]/i);
  var desc = (m ? m[1] : raw).replace(/\[[^\]]*\]/g, ' ').replace(/\s+/g, ' ').trim();
  return desc.length > 120 ? desc.slice(0, 120).trim() + '…' : desc;
}

function ndiRegisterAlgoliaHooks() {
  if (!window.algoliaShopify || !algoliaShopify.hooks || !algoliaShopify.hooks.registerHook) {
    return false;
  }

  // Products-only autocomplete: rebuild the dropdown layout with just the
  // products section, dropping collections / pages / articles / suggestions.
  // The app renders each source into `elements.<sourceId>` and assembles them
  // in this main template — omit `elements.collections` and it's gone.
  algoliaShopify.hooks.registerHook(
    'beforeAutocompleteMainTemplate',
    function (defaultTemplate, templateOptions, elements) {
      var html = templateOptions && templateOptions.html;
      if (!html || !elements) return defaultTemplate; // never break the dropdown
      return html`
        <div class="aa-PanelLayout aa-Panel--scrollable">${elements.products || ''}</div>
      `;
    }
  );

  algoliaShopify.hooks.registerHook(
    'beforeAutocompleteProductTemplate',
    function (defaultTemplate, params) {
      var item = params && params.item;
      var html = params && params.html;
      var components = params && params.components;
      if (!item || !html) return defaultTemplate;

      try {
        var desc = ndiShortDesc(item);
        var title =
          components && components.Highlight
            ? components.Highlight({ hit: item, attribute: 'title' })
            : item.title;
        var onSale =
          item.compare_at_price && Number(item.compare_at_price) > Number(item.price);

        return html`
          <a href="${item.url || '/products/' + item.handle}" class="aa-ItemLink aa-ProductItem">
            <div class="aa-ItemContent">
              <div class="aa-ItemPicture aa-ItemPicture--loaded">
                <img src="${item.product_image}" alt="${item.title}" loading="lazy" />
              </div>
              <div class="aa-ItemContentBody">
                <div class="aa-ItemContentTitleWrapper">
                  <div class="aa-ItemContentTitle">${title}</div>
                </div>
                ${desc && html`<div class="aa-ItemContentDescription">${desc}</div>`}
                <div class="aa-ItemContentPrice">
                  <span class="aa-ItemContentPriceCurrent">${ndiMoney(item.price)}</span>
                  ${onSale
                    ? html`<span class="ndi-aa-was">${ndiMoney(item.compare_at_price)}</span>`
                    : ''}
                </div>
              </div>
            </div>
          </a>
        `;
      } catch (e) {
        return defaultTemplate; // never break the row if the API differs
      }
    }
  );
  return true;
}

// Register as soon as the API is available — immediately if it's already up,
// otherwise when the app fires its init event (timing-robust).
if (!ndiRegisterAlgoliaHooks()) {
  document.addEventListener('algolia.hooks.initialize', ndiRegisterAlgoliaHooks);
}
